// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../public/who-am-i.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../public/knowledged.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --black-shadow: 0 0 1em #000;
  --white-shadow: 0 0 1em #fff;
  --partial-rainbow-border: drop-shadow(0px 0px 10px #000000) drop-shadow(0px 0px 10px #000000) drop-shadow(0 0px 1px #FF0000) drop-shadow(0 0px 1px #FFFF00) drop-shadow(0 0px 1px #00FF00) drop-shadow(0 0px 10px #0000FF) drop-shadow(0 0px 15px #2E2B5F) drop-shadow(0 0px 20px #8B00FF);
  --rainbow-border: drop-shadow(0px 0px 10px #000000) drop-shadow(0px 0px 10px #000000) drop-shadow(0 0px 1px #FF0000) drop-shadow(0 0px 1px #FFFF00) drop-shadow(0 0px 1px #00FF00) drop-shadow(0 0px 10px #0000FF) drop-shadow(0 0px 15px #2E2B5F) drop-shadow(0 0px 20px #8B00FF);
  --grey-gradient: linear-gradient(217deg, rgba(245, 245, 245, 0.5), rgba(245, 245, 245, 0) 70.71%), linear-gradient(127deg, rgb(232, 232, 232, .75), rgb(225, 225, 225) 70.71%), linear-gradient(336deg, rgba(245, 245, 245, 0.8), rgb(232, 232, 232) 70.71%);
}

body {
  font-family: 'Barlow', sans-serif;
}

.App {
  text-align: left;
  transition: all 5s;
  margin: 1%;
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

.navbar {
  /* box-shadow: var(--black-shadow); */
}

.App-header {
  background-color: white;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: gray;
}

.App-link {
  color: #61dafb;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.btn {
  color: black;
  border: 1px solid black;
  font-size: .8em;
  text-transform: uppercase;
  /* background: var(--grey-gradient); */

}

.btn:hover {
  animation: 2s linear 1s infinite alternate btn-text-cycle;
  border: 1px solid black;

  /* font-weight: 600; */
}

.btn-active {
  animation: 2s linear 1s infinite alternate btn-text-cycle;
  border: 1px solid black;

  /* font-weight: 600; */
}

.btn-active + {
  border: 1px solid black;

  /* font-weight: 600; */
}

@keyframes btn-text-cycle {
  0% {
    /* box-shadow: var(--black-shadow); */
    /* box-shadow: 0 0 .5em darkred; */
    border: 1px solid darkred;
    color: darkred;
  }
  14% {
    /* box-shadow: 0 0 .5em darkred; */
    border: 1px solid darkred;
    color: darkred;
  }
  28% {
    /* box-shadow: 0 0 .5em orange; */
    border: 1px solid orange;
    color: orange;
  }
  42% {
    /* box-shadow: 0 0 .5em gold; */
    border: 1px solid gold;
    color: gold;
  }
  56% {
    /* box-shadow: 0 0 .5em green; */
    border: 1px solid green;
    color: green;
  }
  70% {
    /* box-shadow: 0 0 .5em blue; */
    border: 1px solid blue;
    color: blue;
  }
  84% {
    /* box-shadow: 0 0 .5em indigo; */
    border: 1px solid indigo;
    color: indigo;
  }
  100% {
    /* box-shadow: 0 0 .5em violet; */
    border: 1px solid violet;
    color: violet;
  }
}

.row {
  margin: 1%;
}
.col {
  margin: 1%;
}
.navbar {
  background: rgba(0,0,0,0);
}
.navbar-brand {
  font-size: calc(10px + 5vmin);
  font-weight: 800;
  color: #1b1b1b;
}


.portfolio-item-gradient {
  padding: 1%;

  /* border: 1px solid black; */
  /* filter: var(--rainbow-border); */
  background: var(--grey-gradient);
  box-shadow: var(--black-shadow);

  /* filter: var(--rainbow-border); */


}
.portfolio-item-transparent {
  background-color: rgba(245, 245, 245, .70);
  font-weight: 500;
  text-shadow: 0 0 1em rgba(255, 255, 255, 1), 0 0 1em rgba(255, 255, 255, 1), 0 0 1em rgba(255, 255, 255, .25);
}

.portfolio-item:hover {
  transition: all .5s;
  transform: scale(1.0125 );
}

.portfolio-item:hover {
  transition: all .5s;
  transform: scale(1.0125 );
  /* border: 1px solid black; */
  /* filter: var(--rainbow-border); */

}

.about-item-transparent {
  background-color: rgba(245, 245, 245, .25);
  font-weight: 500;
}

a {
  color: black;
  text-decoration: none;
} 

h1 {
  color: black;
}
h2 {
  color: black;
  font-size: 2em;
  text-transform: uppercase;
  margin-left: 4%;

}

.terrain {
  color: #634b3f;
}
.trex {
  color: #6c715d;
}

#art-trex-video {
  border: 2px solid whitesmoke;
}
#portfolio-chorechampion-video {
  border: 5px solid black;
  box-shadow: var(--black-shadow);
}
#portfolio-chorechampion{
  /* background-image: url('../public/portfolio-chorechampion.png'); */
  background-size: cover;
  background-repeat: no-repeat;
}
.chorechampion-heading {
  font-weight: 800;
}

.knock-out-text {
  font-size: 36px;
  text-transform: uppercase;
  font-weight: 800;
  /* color:whitesmoke; */
  text-shadow: var(--white-shadow);
}
.knock-out-subtext {
  /* color:whitesmoke; */
  text-shadow: var(--white-shadow);
}

.email-button {
  text-transform: none;
}

#regexsaurus {
  animation-iteration-count: infinite;
  background-color: darkred !important;
  border-color: red !important;
  color: white !important;
}

#regexsaurus:hover {
  animation: shake 0.5s;
  animation-iteration-count: infinite;
  background-color: darkred !important;
  border-color: red !important;
  color: white !important;
}

@keyframes shake {
  0% { transform: translate(1px, 1px) rotate(0deg); }
  10% { transform: translate(-1px, -2px) rotate(-1deg); }
  20% { transform: translate(-3px, 0px) rotate(1deg); }
  30% { transform: translate(3px, 2px) rotate(0deg); }
  40% { transform: translate(1px, -1px) rotate(1deg); }
  50% { transform: translate(-1px, 2px) rotate(-1deg); }
  60% { transform: translate(-3px, 1px) rotate(0deg) scale(1.2); }
  70% { transform: translate(3px, 1px) rotate(-1deg); }
  80% { transform: translate(-1px, -1px) rotate(1deg); }
  90% { transform: translate(1px, 2px) rotate(0deg); }
  100% { transform: translate(1px, -2px) rotate(-1deg); }
}

p {
  font-weight: 500;
}

.red-text {
  color: darkred;
}

.socialIcon {
  margin-left: 5px;
  margin-right: 5px;
}

/* SCALE AND TRANSFORM ELEMENT WITH CSS. */

.socialIcon:hover {
  transform: scale(1.1);
  transition: all .5s;
}

.who-am-i {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
}

.knowledged-card {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-size: cover; 
}

.text-link {
  color: #f5f5f5;
  text-decoration: underline;
  text-underline-offset: 0.35em;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,4BAA4B;EAC5B,4BAA4B;EAC5B,0RAA0R;EAC1R,kRAAkR;EAClR,4PAA4P;AAC9P;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,yBAAyB;EACzB,sCAAsC;;AAExC;;AAEA;EACE,yDAAyD;EACzD,uBAAuB;;EAEvB,sBAAsB;AACxB;;AAEA;EACE,yDAAyD;EACzD,uBAAuB;;EAEvB,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;;EAEvB,sBAAsB;AACxB;;AAEA;EACE;IACE,qCAAqC;IACrC,kCAAkC;IAClC,yBAAyB;IACzB,cAAc;EAChB;EACA;IACE,kCAAkC;IAClC,yBAAyB;IACzB,cAAc;EAChB;EACA;IACE,iCAAiC;IACjC,wBAAwB;IACxB,aAAa;EACf;EACA;IACE,+BAA+B;IAC/B,sBAAsB;IACtB,WAAW;EACb;EACA;IACE,gCAAgC;IAChC,uBAAuB;IACvB,YAAY;EACd;EACA;IACE,+BAA+B;IAC/B,sBAAsB;IACtB,WAAW;EACb;EACA;IACE,iCAAiC;IACjC,wBAAwB;IACxB,aAAa;EACf;EACA;IACE,iCAAiC;IACjC,wBAAwB;IACxB,aAAa;EACf;AACF;;AAEA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,6BAA6B;EAC7B,gBAAgB;EAChB,cAAc;AAChB;;;AAGA;EACE,WAAW;;EAEX,6BAA6B;EAC7B,mCAAmC;EACnC,gCAAgC;EAChC,+BAA+B;;EAE/B,mCAAmC;;;AAGrC;AACA;EACE,0CAA0C;EAC1C,gBAAgB;EAChB,6GAA6G;AAC/G;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,6BAA6B;EAC7B,mCAAmC;;AAErC;;AAEA;EACE,0CAA0C;EAC1C,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,YAAY;AACd;AACA;EACE,YAAY;EACZ,cAAc;EACd,yBAAyB;EACzB,eAAe;;AAEjB;;AAEA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,4BAA4B;AAC9B;AACA;EACE,uBAAuB;EACvB,+BAA+B;AACjC;AACA;EACE,oEAAoE;EACpE,sBAAsB;EACtB,4BAA4B;AAC9B;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,sBAAsB;EACtB,gCAAgC;AAClC;AACA;EACE,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mCAAmC;EACnC,oCAAoC;EACpC,4BAA4B;EAC5B,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;EACrB,mCAAmC;EACnC,oCAAoC;EACpC,4BAA4B;EAC5B,uBAAuB;AACzB;;AAEA;EACE,KAAK,2CAA2C,EAAE;EAClD,MAAM,8CAA8C,EAAE;EACtD,MAAM,4CAA4C,EAAE;EACpD,MAAM,2CAA2C,EAAE;EACnD,MAAM,4CAA4C,EAAE;EACpD,MAAM,6CAA6C,EAAE;EACrD,MAAM,uDAAuD,EAAE;EAC/D,MAAM,4CAA4C,EAAE;EACpD,MAAM,6CAA6C,EAAE;EACrD,MAAM,2CAA2C,EAAE;EACnD,OAAO,6CAA6C,EAAE;AACxD;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,0CAA0C;;AAE1C;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,yDAA+C;EAC/C,sBAAsB;AACxB;;AAEA;EACE,yDAAiD;EACjD,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,0BAA0B;EAC1B,6BAA6B;AAC/B","sourcesContent":[":root {\n  --black-shadow: 0 0 1em #000;\n  --white-shadow: 0 0 1em #fff;\n  --partial-rainbow-border: drop-shadow(0px 0px 10px #000000) drop-shadow(0px 0px 10px #000000) drop-shadow(0 0px 1px #FF0000) drop-shadow(0 0px 1px #FFFF00) drop-shadow(0 0px 1px #00FF00) drop-shadow(0 0px 10px #0000FF) drop-shadow(0 0px 15px #2E2B5F) drop-shadow(0 0px 20px #8B00FF);\n  --rainbow-border: drop-shadow(0px 0px 10px #000000) drop-shadow(0px 0px 10px #000000) drop-shadow(0 0px 1px #FF0000) drop-shadow(0 0px 1px #FFFF00) drop-shadow(0 0px 1px #00FF00) drop-shadow(0 0px 10px #0000FF) drop-shadow(0 0px 15px #2E2B5F) drop-shadow(0 0px 20px #8B00FF);\n  --grey-gradient: linear-gradient(217deg, rgba(245, 245, 245, 0.5), rgba(245, 245, 245, 0) 70.71%), linear-gradient(127deg, rgb(232, 232, 232, .75), rgb(225, 225, 225) 70.71%), linear-gradient(336deg, rgba(245, 245, 245, 0.8), rgb(232, 232, 232) 70.71%);\n}\n\nbody {\n  font-family: 'Barlow', sans-serif;\n}\n\n.App {\n  text-align: left;\n  transition: all 5s;\n  margin: 1%;\n}\n\n.App-logo {\n  height: 40vmin;\n  pointer-events: none;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n}\n\n.navbar {\n  /* box-shadow: var(--black-shadow); */\n}\n\n.App-header {\n  background-color: white;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: gray;\n}\n\n.App-link {\n  color: #61dafb;\n}\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.btn {\n  color: black;\n  border: 1px solid black;\n  font-size: .8em;\n  text-transform: uppercase;\n  /* background: var(--grey-gradient); */\n\n}\n\n.btn:hover {\n  animation: 2s linear 1s infinite alternate btn-text-cycle;\n  border: 1px solid black;\n\n  /* font-weight: 600; */\n}\n\n.btn-active {\n  animation: 2s linear 1s infinite alternate btn-text-cycle;\n  border: 1px solid black;\n\n  /* font-weight: 600; */\n}\n\n.btn-active + {\n  border: 1px solid black;\n\n  /* font-weight: 600; */\n}\n\n@keyframes btn-text-cycle {\n  0% {\n    /* box-shadow: var(--black-shadow); */\n    /* box-shadow: 0 0 .5em darkred; */\n    border: 1px solid darkred;\n    color: darkred;\n  }\n  14% {\n    /* box-shadow: 0 0 .5em darkred; */\n    border: 1px solid darkred;\n    color: darkred;\n  }\n  28% {\n    /* box-shadow: 0 0 .5em orange; */\n    border: 1px solid orange;\n    color: orange;\n  }\n  42% {\n    /* box-shadow: 0 0 .5em gold; */\n    border: 1px solid gold;\n    color: gold;\n  }\n  56% {\n    /* box-shadow: 0 0 .5em green; */\n    border: 1px solid green;\n    color: green;\n  }\n  70% {\n    /* box-shadow: 0 0 .5em blue; */\n    border: 1px solid blue;\n    color: blue;\n  }\n  84% {\n    /* box-shadow: 0 0 .5em indigo; */\n    border: 1px solid indigo;\n    color: indigo;\n  }\n  100% {\n    /* box-shadow: 0 0 .5em violet; */\n    border: 1px solid violet;\n    color: violet;\n  }\n}\n\n.row {\n  margin: 1%;\n}\n.col {\n  margin: 1%;\n}\n.navbar {\n  background: rgba(0,0,0,0);\n}\n.navbar-brand {\n  font-size: calc(10px + 5vmin);\n  font-weight: 800;\n  color: #1b1b1b;\n}\n\n\n.portfolio-item-gradient {\n  padding: 1%;\n\n  /* border: 1px solid black; */\n  /* filter: var(--rainbow-border); */\n  background: var(--grey-gradient);\n  box-shadow: var(--black-shadow);\n\n  /* filter: var(--rainbow-border); */\n\n\n}\n.portfolio-item-transparent {\n  background-color: rgba(245, 245, 245, .70);\n  font-weight: 500;\n  text-shadow: 0 0 1em rgba(255, 255, 255, 1), 0 0 1em rgba(255, 255, 255, 1), 0 0 1em rgba(255, 255, 255, .25);\n}\n\n.portfolio-item:hover {\n  transition: all .5s;\n  transform: scale(1.0125 );\n}\n\n.portfolio-item:hover {\n  transition: all .5s;\n  transform: scale(1.0125 );\n  /* border: 1px solid black; */\n  /* filter: var(--rainbow-border); */\n\n}\n\n.about-item-transparent {\n  background-color: rgba(245, 245, 245, .25);\n  font-weight: 500;\n}\n\na {\n  color: black;\n  text-decoration: none;\n} \n\nh1 {\n  color: black;\n}\nh2 {\n  color: black;\n  font-size: 2em;\n  text-transform: uppercase;\n  margin-left: 4%;\n\n}\n\n.terrain {\n  color: #634b3f;\n}\n.trex {\n  color: #6c715d;\n}\n\n#art-trex-video {\n  border: 2px solid whitesmoke;\n}\n#portfolio-chorechampion-video {\n  border: 5px solid black;\n  box-shadow: var(--black-shadow);\n}\n#portfolio-chorechampion{\n  /* background-image: url('../public/portfolio-chorechampion.png'); */\n  background-size: cover;\n  background-repeat: no-repeat;\n}\n.chorechampion-heading {\n  font-weight: 800;\n}\n\n.knock-out-text {\n  font-size: 36px;\n  text-transform: uppercase;\n  font-weight: 800;\n  /* color:whitesmoke; */\n  text-shadow: var(--white-shadow);\n}\n.knock-out-subtext {\n  /* color:whitesmoke; */\n  text-shadow: var(--white-shadow);\n}\n\n.email-button {\n  text-transform: none;\n}\n\n#regexsaurus {\n  animation-iteration-count: infinite;\n  background-color: darkred !important;\n  border-color: red !important;\n  color: white !important;\n}\n\n#regexsaurus:hover {\n  animation: shake 0.5s;\n  animation-iteration-count: infinite;\n  background-color: darkred !important;\n  border-color: red !important;\n  color: white !important;\n}\n\n@keyframes shake {\n  0% { transform: translate(1px, 1px) rotate(0deg); }\n  10% { transform: translate(-1px, -2px) rotate(-1deg); }\n  20% { transform: translate(-3px, 0px) rotate(1deg); }\n  30% { transform: translate(3px, 2px) rotate(0deg); }\n  40% { transform: translate(1px, -1px) rotate(1deg); }\n  50% { transform: translate(-1px, 2px) rotate(-1deg); }\n  60% { transform: translate(-3px, 1px) rotate(0deg) scale(1.2); }\n  70% { transform: translate(3px, 1px) rotate(-1deg); }\n  80% { transform: translate(-1px, -1px) rotate(1deg); }\n  90% { transform: translate(1px, 2px) rotate(0deg); }\n  100% { transform: translate(1px, -2px) rotate(-1deg); }\n}\n\np {\n  font-weight: 500;\n}\n\n.red-text {\n  color: darkred;\n}\n\n.socialIcon {\n  margin-left: 5px;\n  margin-right: 5px;\n}\n\n/* SCALE AND TRANSFORM ELEMENT WITH CSS. */\n\n.socialIcon:hover {\n  transform: scale(1.1);\n  transition: all .5s;\n}\n\n.who-am-i {\n  background-image: url('../public/who-am-i.jpg');\n  background-size: cover;\n}\n\n.knowledged-card {\n  background-image: url('../public/knowledged.jpg');\n  background-size: cover; \n}\n\n.text-link {\n  color: #f5f5f5;\n  text-decoration: underline;\n  text-underline-offset: 0.35em;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
